import React from 'react';
import Tooltip, { type TooltipProps } from '@atlaskit/tooltip';

type Props = TooltipProps & {
	condition: boolean;
};

export const ConditionalTooltip = ({ condition, children, ...rest }: Props) =>
	condition ? <Tooltip {...rest}>{children}</Tooltip> : <>{children}</>;
